import { render, staticRenderFns } from "./viewDetails.vue?vue&type=template&id=22c0dfdf"
import script from "./viewDetails.vue?vue&type=script&lang=js"
export * from "./viewDetails.vue?vue&type=script&lang=js"
import style0 from "./viewDetails.vue?vue&type=style&index=0&id=22c0dfdf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports